{
    "RunondayMonthLabel": "Executar no dia (mês):",
    "RunondayWeekLabel": "Executar no dia (semana):",
    "RunondaysLabel": "Executar relatório em dias:",
    "RunbetweenhoursStartLabel": "Executar entre horas:",
    "RunbetweenhoursEndLabel": "E:",
    "RunbetweenhoursNote": "(Incluíndo a hora de fim completa)",
    "RunatminuteHourLabel": "Executar no minuto (hora):",
    "RunatminuteHourNote": "A cada hora (aproximadamente)",
    "RunondateLabel": "Executar relatório na data:",
    "RunattimeLabel": "Executar no tempo (aproximadamente):",
    "TimeOptions_SectionHeader": "Opções de horário",
    "NAME": "TimeOptions"
}